import { createFileRoute } from "@tanstack/react-router";
import { AgreementPage } from "@/features/agreementpage/AgreementPage";

export const Route = createFileRoute("/_app/agreements/$agreement")({ component: Page });

function Page() {
  const { agreement } = Route.useParams();
  return <AgreementPage id={agreement} />;
}
